import { AdminManagement } from 'pages/admins';

import { Unauthorized } from 'components/unauthorized';

import { useCanAccess } from 'hooks/useCanAccess';
import { TokenExpired } from 'components/tokenExpired';

export const AdminManagementRoute = () => {
  const { isExpired, isAdmin } = useCanAccess('admins');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminManagement />
  ) : (
    <Unauthorized />
  );
};
